const BootLoader = require('components/BootLoader');

module.exports = BootLoader;
